<template>
    <div class="testimonials" v-if="testimonials.length > 0">
        <div class="swiper-container testimonials-carousel">
            <div class="swiper-wrapper">
                <!-- Slides -->
                <div class="swiper-slide" v-for="(testimonial, index) in testimonials" :key="index">
                    <div class="row testimonial">
                        <div class="col-12 col-sm-1">
                            <div class="testimonial__user"> {{testimonial.title}} </div>
                        </div>
                        <div class="col-12 col-sm-9 col-lg-8">
                            <div class="testimonial__text" v-html="testimonial.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                
            }
        },
        props: ['testimonials']
    }
</script>